import { useState, useEffect } from 'react';
import { ajax } from 'jquery';
import QrScanner from 'qr-scanner';
import './index.css';
let qrScanner: QrScanner
const HASH_REGEX = /cb\.pixelhouse\.cn\/card\/([a-zA-Z\d]+)/
function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}
const Myballs = () => {
    const [userData, setUserData] = useState<any>()
    const [showCamera, setCameraShown] = useState(false)

    useEffect(() => {
        const loadUserData = async () => {
            const result = await ajax({
                method: "GET",
                url: '/api/v1/countryball_card/user',
            })
            setUserData(result)
        }
        loadUserData()
    }, [])

    const scanQRCode = async () => {
        if (await QrScanner.hasCamera()) {
            setCameraShown(true);
            qrScanner = qrScanner || new QrScanner(
                document.querySelector("video")!,
                result => {
                    const url = result.data;

                    if (HASH_REGEX.test(url)) {
                        qrScanner.stop();
                        window.location.href = url;
                    }
                },
                {
                    highlightScanRegion: true,
                    highlightCodeOutline: true,
                }
            );
            qrScanner.start()
        }
    }

    const closeCamera = () => {
        qrScanner.stop();
        setCameraShown(false)
    }

    const randomFace = () => {
        // 随机生成一个1-14之间的数字,然后随机再后面加上_l _r 或者不加
        const randomNumber = Math.floor(Math.random() * 14) + 1
        //随机跟上后缀_l _r 或者不加
        const randomSide = Math.random() < 0.33 ? '_l' : Math.random() < 0.66 ? '_r' : ''
        return randomNumber + randomSide
    }

    return (
        <div className='page-wrap card-page myballs-page'>
            <div className="myballs-page-content">
                <h3 className="myballs-title">我拥有的国家球</h3>
                <div className="myballs-list">
                    {
                        userData && userData.activedCountries.map((country: any, index: number) => {
                            return <a className='ball-wrap myballs-ball-wrap' href={'/card/' + country.hash} key={index}>
                                <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(country.name_en) + '.png'} alt={country.name_en} />
                                <img className='face-pic' src={`https://oss.usecubes.cn/countryballs/faces/${randomFace()}.png`} />
                            </a>
                        })
                    }
                </div>
                <div className="add-new-ball-box">
                    <a href="#" onClick={scanQRCode} className="common-btn add-new-ball">扫码添加新国家球</a>
                    <p className="add-new-ball-tip">
                        部分手机型号无法扫码可使用微信扫一扫替代
                    </p>
                </div>
            </div>
            <div className={"scan-qr-layer" + (showCamera ? " show" : "")}>
                <div className="scan-qr-box">
                    <p className="scan-qr-title">扫描卡片背面的二维码</p>
                    <button onClick={closeCamera}>
                        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Menu / Close_LG">
                                <path id="Vector" d="M21 21L12 12M12 12L3 3M12 12L21.0001 3M12 12L3 21.0001" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                        </svg>
                    </button>
                    <video className="scan-qr-video"></video>
                </div>
            </div>
        </div >
    );
}

export default Myballs